import React from "react";
import StatusApplication from "./StatusApplication";
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const TotalApplication = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editTotalApplications.role,
    permissionsConfig.editTotalApplications.action,
    permissionsConfig.editTotalApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteTotalApplications.role,
    permissionsConfig.deleteTotalApplications.action,
    permissionsConfig.deleteTotalApplications.type
  );

  return (
    <StatusApplication appStatus="" title="All" subTitle="All" application_type="0" pageFrom="total-applications" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
};

export default TotalApplication;
